export default () => ({
    list: [],
})